'use strict';

import React from 'react'

import Layout   from '@Layout/BackOffice'
import Loader   from '@Pure/Loader'
import Image    from '@Pure/Image'
import DataList from '@/DataList'

import Artists_config   from '@Config/Configuration/artist'
import Places_config    from '@Config/Configuration/place'
import Position_config  from '@Config/Configuration/show_position'
import Publics_config   from '@Config/Configuration/public'
import Ages_config      from '@Config/Configuration/age'
import Themes_config    from '@Config/Configuration/show_theme'

export default class ConfigPage extends React.Component
{
	constructor (props)
	{
		super();

		this.state = { loading: true, members: 0, ECs: 0, products: 0 };

		window.app = window.app || { };

		this.permissions = window.app.permissions;
	}

	componentWillMount ()
	{
		var component = this, props = this.props;

		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props;

		var loader;

		var configs =
		{
			Artists: Object.assign({ }, Artists_config),
			Places: Object.assign({ }, Places_config),
			Position: Object.assign({ }, Position_config),
			Publics: Object.assign({ }, Publics_config),
			Ages: Object.assign({ }, Ages_config),
			Themes: Object.assign({ }, Themes_config)
		};

		Object.keys(configs).forEach(function (config_name)
		{
			Object.assign(configs[config_name],
			{
				filter_query:
				{
					limit: 3
				}
			});
		});

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['yellow', 'bg-white'] } />;
		}

		var output =
		(
			<Layout history={ props.history } page_title="Tableau de bord">

				<div className="page-content">

					<div className="o-grid-2">

						<div className="o-grid__item">
							<div className="dashboard-list">
								<DataList add_btn={ false } config={ configs.Artists }
									pagination={ false } />
							</div>

							<div className="dashboard-list">
								<DataList add_btn={ false } config={ configs.Places }
									pagination={ false } />
							</div>

							<div className="dashboard-list">
								<DataList add_btn={ false } config={ configs.Themes }
									pagination={ false } />
							</div>
						</div>

						<div className="o-grid__item">
							<div className="dashboard-list">
								<DataList add_btn={ false } config={ configs.Ages }
									pagination={ false } />
							</div>

							<div className="dashboard-list">
								<DataList add_btn={ false } config={ configs.Position }
									pagination={ false } />
							</div>

							<div className="dashboard-list">
								<DataList add_btn={ false } config={ configs.Publics }
									pagination={ false } />
							</div>
						</div>

					</div> { /* /o-grid */ }

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}